export const SYSTEM_NOTIFICATIONS_CONFIG_NAME = 'system_notifications';

// Polling interval for fetching notification config
export const DEFAULT_POLL_INTERVAL_MS = 60_000; // 1 minute
